import "@material/react-chips/dist/chips.css";

import Autocomplete from "@material-ui/lab/Autocomplete";
import React from "react";
import RestChipDataService from "../../services/RestChipDataService";
import TextField from "@material-ui/core/TextField";

export default class ChipsView extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;

    //init
    this.state = {
      betreff: []
    };
  }

  componentDidMount() {
    var service = RestChipDataService();
    service
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          betreff: data
        });
      });
  }

  render() {
    return (
      <div style={{}}>
        <Autocomplete
          clearText="Löschen"
          noOptionsText="Nichts gefunden"
          openText="Öffnen"
          data-testid="combobox"
          id="tags-outlined"
          options={this.state.betreff}
          getOptionLabel={(option) => option.label}
          filterSelectedOptions
          onChange={(event, newValue) => {
            this.props.update(newValue);
          }}
          className={this.props.classes}
          renderInput={(params) => <TextField {...params} variant="outlined" style={{ backgroundColor: "white" }} />}
        />
      </div>
    );
  }
}
